import { cn } from '@morpho-org/ui-v6/utils'
import { Button } from '@repo/ui'
import { forwardRef, memo } from 'react'

/* OperationModeButton for the different operation modes
 * This component is used to display the buttons for the different operations modes
 */
const OperationModeButton = (
  {
    label,
    onClick,
    isActive,
    dataTestId,
    disabled
  }: {
    label: string
    isActive: boolean
    dataTestId?: string
    onClick?: () => void
    disabled?: boolean
  },
  ref: React.ForwardedRef<HTMLButtonElement>
) => {
  return (
    <Button
      variant={isActive ? 'secondary' : 'ghost'}
      aria-pressed={isActive}
      onClick={onClick}
      ref={ref}
      data-testid={dataTestId}
      disabled={disabled}
      // Instant pill toggle (matches the pre-@repo/ui Button, which had no transitions): with
      // `transition-all`, the ghost->secondary swap on click animates the border from
      // `currentColor` (white in dark) — a white flash. Dark active pill stays flat (no chrome).
      className={cn(
        'transition-none',
        isActive && 'dark:border-transparent dark:bg-secondary dark:shadow-none'
      )}
    >
      {label}
    </Button>
  )
}
export default memo(forwardRef(OperationModeButton))
